import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'
import { BlueButton, NavButton } from 'components/Button'
import { push } from 'connected-react-router'
import { Description, MainHeadline } from 'components/Typography'

const StoreDeliverySettingTemplate: FC = () => {
  const dispatch = useDispatch()

  const goToStoreDeliveryFee = useCallback(() => dispatch(push('/delivery/setting/fee')), [])
  const goToStoreDeliverySettingYamato = useCallback(() => dispatch(push('/delivery/setting/yamato')), [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'配送設定'} />
      <Spacer size={28} />
      <Description description={'確認したいページをクリックしてください。'} />
      <Spacer size={20} />
      <Description
        fontWeight={'bold'}
        description={
          '商品の配送料やクール便の料金を登録します。配送料が設定されていないサイズは、商品の登録ができませんのでご注意ください'
        }
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'配送料設定'}
        onClick={goToStoreDeliveryFee}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <Description
        fontWeight={'bold'}
        description={
          'ヤマトのビジネスメンバーズ情報を登録します。注文の伝票データを、CSVで書き出しするために必要です。'
        }
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'ヤマトビジネスメンバーズ情報'}
        onClick={goToStoreDeliverySettingYamato}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default StoreDeliverySettingTemplate
